module.exports = __webpack_public_path__ + "img/rencaiku.13280a96.svg";